import React from 'react'
import {DIGITAL_HERO_PAGE_1 , DIGITAL_COURSE_PAGE_1,DIGITAL_DETAILS_PAGE_1, BANKING_BOTTOM_CONTENT} from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'
import { DIGITAL_ACCORDIAN_1 } from '../../../utils/courseConifg'

const DigitalPage_1 = () => {
  return (
    <div className='outlet-render'>
        <CourseAsideHero  {...DIGITAL_HERO_PAGE_1}/>
      <CoursesAside {...DIGITAL_COURSE_PAGE_1}/>
      <CourseCard {...DIGITAL_DETAILS_PAGE_1}/>
      <Accordian {...DIGITAL_ACCORDIAN_1}/>
      <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default DigitalPage_1